import React from "react";
import { connect } from "react-redux";
import { Pane, SelectField, Heading, Text, Button } from "evergreen-ui";
import { downloadReport } from "../external/actions";
import { getCurrentDate } from "../util";
import BackBar from "../components/backBar";
import DateRangePicker from "../components/dateRangePicker";

class Reports extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      reportType: "booking",
      reportsDescription: {
        booking: `The booking report enables you to view a list of your bookings based on date range, handler and the type of transaction.
                Available for download.`,
        cancellation: `The cancellation report lists the details of cancelled bookings.
                Available for download.`,
      },
      toDate: getCurrentDate("YYYY-MM-DD"),
      fromDate: getCurrentDate("YYYY-MM-DD"),
      currentDate: getCurrentDate("YYYY-MM-DD"),
    };
    this.baseState = this.state;
  }

  inputChange = async (e) => {
    await this.setState({
      reportType: e.target.value,
    });
  };

  dateChange = (dateChangeData) => {
    this.setState({ ...dateChangeData });
  };

  downloadReportHandler = async () => {
    const { fromDate, toDate, reportType } = this.state;
    await this.props.dispatch(
      downloadReport(
        {
          startDate: fromDate,
          endDate: toDate,
          booked: 1,
        },
        reportType
      )
    );
  };

  render() {
    const { reportType, reportsDescription, fromDate, toDate, currentDate } =
      this.state;

    return (
      <React.Fragment>
        <BackBar title={"Reports"} />
        <Pane
          position={"sticky"}
          top={60}
          paddingTop={10}
          paddingBottom={1}
          paddingLeft={15}
          paddingRight={15}
          background={"tint1"}
        >
          <SelectField
            label={"Select Report Type"}
            onChange={(e) => this.inputChange(e)}
          >
            <option value="booking">Booking Report</option>
            <option value="cancellation">Cancellation Report</option>
          </SelectField>
        </Pane>
        <Pane
          paddingLeft={15}
          paddingRight={15}
          paddingTop={10}
          paddingBottom={20}
        >
          <Heading marginY={10} size={500}>
            {`${reportType === "booking" ? "Booking" : "Cancellation"} Report`}
          </Heading>
          <Text whiteSpace={"pre-line"} size={300}>
            {`${reportsDescription[reportType]}`}
          </Text>
        </Pane>
        <DateRangePicker
          fromDate={fromDate}
          toDate={toDate}
          currentDate={currentDate}
          dateChange={this.dateChange}
          paddingLeft={15}
          paddingRight={15}
          disableFutureDates={false}
          report={true}
        />
        <Pane paddingLeft={15} paddingRight={15} marginTop={20}>
          <Button
            height={40}
            appearance={"primary"}
            display={"flex"}
            justifyContent={"center"}
            width={"100%"}
            onClick={this.downloadReportHandler}
          >
            Download
          </Button>
        </Pane>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ bookingSearchData }) => ({
  bookingSearchData,
});

export default connect(mapStateToProps)(Reports);
